import { getSpecConfig } from "../specs";
import { Category, ProductType } from "../specs/product";

export const getAllCategories = (productTypes: ProductType[]): Category[] => {
  const specConfigs = productTypes.map(type => getSpecConfig(type));
  return specConfigs.flatMap(specConfig => Object.values(specConfig.categories));
};

export const ALL_CATEGORIES = getAllCategories(Object.values(ProductType));
